import { pages } from '../util/global-methods';

const routes = [
  // {path: 'promotion', component: pages('event'), props: true, meta: {store: 'event'}},
  // {path: 'promotion/details/:key', component: pages('event/detail'), props: true, meta: {store: 'event'}}
];

export default routes;
